import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authApi } from '../services/api';
import './CompanionInstructions.css';

export default function CompanionInstructions() {
  const navigate = useNavigate();
  const location = useLocation();
  const devBypass = Boolean((location.state as { devBypass?: boolean } | null)?.devBypass);
  const { refresh, user, loading: authLoading } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!authLoading && !user && !devBypass) {
      navigate('/register-code', { replace: true });
    }
  }, [authLoading, user, navigate, devBypass]);

  const handleEnterBriefingRoom = async () => {
    setLoading(true);
    setError('');
    try {
      await authApi.enterBriefingRoom();
      await refresh();
      navigate('/workspace', { replace: true });
    } catch (err: unknown) {
      setError((err as { error?: string }).error || 'Unable to enter the Briefing Room.');
      setLoading(false);
    }
  };

  if (authLoading || (!user && !devBypass)) {
    return null;
  }

  return (
    <div className="page-center companion-instructions-screen">
      <div className="modal-box companion-instructions-panel">
        <h2 className="section-header">How to Engage with Your Companion</h2>
        <p className="scannable-bullet-text companion-instructions-body">
          Mentology operates on an active-participation protocol. There is no passive listening in this space.
          To experience full breakthrough, you must speak directly, transparently, and challenge your own baseline
          assumptions. Your Companion delivers the clinical frameworks and knowledge stored strictly inside the
          Mentology Vault. She serves as your mirror.
        </p>
        <ul className="companion-instructions-list scannable-bullet-text">
          <li>Use the Microphone button or type directly into the input box to communicate.</li>
          <li>Speak in clear, full sentences for optimal processing.</li>
          <li>Expect direct, accountability-driven feedback designed to push past blind spots.</li>
        </ul>
        {error && <p className="error-text">{error}</p>}
        <div className="button-control-group">
          <button
            type="button"
            className="btn-primary"
            onClick={handleEnterBriefingRoom}
            disabled={loading}
          >
            {loading ? 'Entering...' : 'ENTER BRIEFING ROOM'}
          </button>
        </div>
      </div>
    </div>
  );
}
